module.exports = __webpack_public_path__ + "img/collect_T.6777eb8f.png";